import React, { useState, useEffect } from 'react';
import L from 'leaflet';

function App() {
  const [kiinteistot, setKiinteistot] = useState([]);
  
  useEffect(() => {
    const map = L.map('map').setView([60.17, 24.94], 13);  // Alustava sijainti (Helsinki)

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    map.on('click', async (e) => {
      const lat = e.latlng.lat;
      const lon = e.latlng.lng;

      const response = await fetch(`http://localhost:8000/api/kiinteistot?lat=${lat}&lon=${lon}`);
      const data = await response.json();
      setKiinteistot(data.features);

      // Piirretään kiinteistöt kartalle
      data.features.forEach((feature) => {
        const coordinates = feature.geometry.coordinates[0].map(coord => [coord[1], coord[0]]);
        L.polygon(coordinates).addTo(map);
      });
    });
  }, []);

  return (
    <div>
      <h1>Kiinteistökartta</h1>
      <div id="map" style={{ height: '600px' }}></div>
      <div>
        {kiinteistot.map((kiinteisto, index) => (
          <div key={index}>
            <h3>{kiinteisto.kiinteistotunnus}</h3>
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;
